import Skeleton from "@mui/material/Skeleton"
import { isMobile } from "../../utils/browser"

const Loading = () => {
  const extraProps = {
    style: {
      marginBottom: 20,
      width: isMobile() ? 300 : 600,
      variant: "rectangle",
    },
  }

  return (
    <>
      <Skeleton height={40} {...extraProps} />
      <Skeleton height={80} {...extraProps} />
      <Skeleton height={40} {...extraProps} />
      <Skeleton height={80} {...extraProps} />
      <Skeleton height={160} {...extraProps} />
    </>
  )
}

export default Loading
